export default __webpack_public_path__ + "static/media/10.47d55dc5.jpeg";